<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Navigation -->
<fuse-vertical-navigation
	class="dark bg-gray-900 print:hidden"
	[appearance]="navigationAppearance()"
	[mode]="isScreenSmall ? 'over' : 'side'"
	[name]="'mainNavigation'"
	[navigation]="navigation.default"
	[opened]="!isScreenSmall"
>
	<!-- Navigation header hook -->
	<ng-container fuseVerticalNavigationContentHeader>
		<!-- Logo -->
		<div class="flex items-center justify-center h-16 mb-0">
			<div class="w-12">
				<img
					class="scale-110"
					src="assets/images/logo/logo-bird.svg"
					alt="Claim Mosaic"
				/>
			</div>
		</div>

		<cm-company-switcher
			[isCollapsedSidebar]="navigationAppearance() === 'dense'"
		></cm-company-switcher>
	</ng-container>
	<ng-container fuseVerticalNavigationFooter>
		<div
			class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
		>
			<span
				class="fuse-vertical-navigation-footer-text font-medium text-secondary text-ellipsis overflow-hidden whitespace-nowrap"
				>Claim Mosaic &copy; {{ currentYear }}</span
			>
		</div>
	</ng-container>
</fuse-vertical-navigation>

<div class="flex w-full h-full sm:h-screen overflow-hidden">
	<!-- Wrapper -->
	<div class="flex flex-col flex-auto w-full min-w-0">
		<!-- Header -->
		<div
			class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
		>
			<div class="flex items-center pr-2 space-x-2">
				<!-- Navigation toggle button -->
				<button
					mat-icon-button
					(click)="toggleNavigation('mainNavigation')"
				>
					<mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
				</button>
			</div>
			<div class="flex flex-1 justify-center">
				<div class="hidden md:block w-3/5">
					<cm-search-dropdown></cm-search-dropdown>
				</div>
			</div>
			<!-- Components -->
			<div class="flex items-center pl-2 space-x-0.5 sm:space-x-2">
				<search class="md:hidden" [appearance]="'bar'"></search>
				<shortcuts></shortcuts>
				@if (isSupportDelegationActive()) {
					<button
						type="button"
						class="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-100 px-2.5 py-1 text-xs font-semibold uppercase tracking-wide text-amber-900 hover:bg-amber-200 dark:border-amber-500/60 dark:bg-amber-900/40 dark:text-amber-100"
						[matTooltip]="supportDelegationTooltip()"
						(click)="clearDelegationAndLogout()"
					>
						<mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
						<span>Impersonating</span>
					</button>
				}
				<user></user>
				<ng-container
					*hasPermission="[
						'admin:all',
						'admin:global',
						'general:mosaicaiassistant'
					]"
				>
					<button
						mat-icon-button
						(click)="toggleAIAssistant()"
						matTooltip="Activate AI Assistant"
						*minimumTier="'Enterprise'"
					>
						<img
							class="scale-100"
							src="assets/icons/claimmosaic-ai.svg"
							alt="Claim Mosaic"
						/>
					</button>
				</ng-container>
			</div>
		</div>
		<!-- Content -->
		<div class="flex flex-col flex-auto">
			<!-- *ngIf="true" hack is required here for router-outlet to work correctly.
        Otherwise, layout changes won't be registered and the view won't be updated! -->
			@if (true) {
			<router-outlet></router-outlet>
			}
		</div>
		<!-- Footer -->
		@if (false) {
		<div
			class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
		>
			<span class="font-medium text-secondary"
				>Claim Mosaic &copy; {{ currentYear }}</span
			>
		</div>
		}
	</div>

	<!-- AI chat -->
	<ng-container
		*hasPermission="[
			'admin:all',
			'admin:global',
			'general:mosaicaiassistant'
		]"
	>
		<ai-chat #aiChat="aiChat"></ai-chat>
	</ng-container>
</div>
